import type { ParticipantTask } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { ParticipantTaskItem } from './ParticipantTaskItem';

interface Props {
  tasks: ParticipantTask[];
  initialVisibleCount: number;
  isDisabled: boolean;
  onChangeStatus: (task: ParticipantTask) => void;
}

export const ParticipantTaskItemList = (props: Props) => {
  const { tasks, isDisabled, initialVisibleCount, onChangeStatus } = props;
  const [showAll, setShowAll] = React.useState(false);
  const visibleTasks = showAll ? tasks : P.take(tasks, initialVisibleCount);

  return (
    <ChakraV3.Stack w='full'>
      {visibleTasks.map((task) => (
        <ParticipantTaskItem
          key={task.id}
          task={task}
          isDisabled={isDisabled}
          onChangeStatus={() => onChangeStatus(task)}
        />
      ))}

      {tasks.length > initialVisibleCount && (
        <ChakraV3.Button
          alignSelf='start'
          size='xs'
          onClick={() => setShowAll(!showAll)}
          variant='plain'
        >
          {showAll ? 'Show less' : 'Show more'}
        </ChakraV3.Button>
      )}
    </ChakraV3.Stack>
  );
};
